import type { MeDTO } from '@amrita/shared';

const API_BASE = import.meta.env.VITE_API_BASE ?? '';

async function jsonPost<T>(path: string, body: unknown): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify(body),
  });
  const json = await res.json();
  if (!res.ok || !json.ok) throw new Error(json?.error?.error ?? `HTTP ${res.status}`);
  return json.data as T;
}

async function jsonGet<T>(path: string): Promise<T> {
  const res = await fetch(`${API_BASE}${path}`, { credentials: 'same-origin' });
  const json = await res.json();
  if (!res.ok || !json.ok) throw new Error(json?.error?.error ?? `HTTP ${res.status}`);
  return json.data as T;
}

export interface AuthConfig { botUsername: string }
export interface InvitePrefill { fullName: string | null; tgUsername: string | null }

export const authApi = {
  config: () => jsonGet<AuthConfig>('/api/auth/config'),
  login: (login: string, password: string) => jsonPost<MeDTO>('/api/auth/login', { login, password }),
  telegram: (data: Record<string, unknown>) => jsonPost<MeDTO>('/api/auth/telegram', data),
  invite: (token: string) => jsonGet<InvitePrefill>(`/api/auth/invite/${encodeURIComponent(token)}`),
  redeem: (token: string, fullName: string, login: string, password: string) =>
    jsonPost<MeDTO>('/api/auth/redeem', { token, fullName, login, password }),
  logout: () => jsonPost<{ ok: true }>('/api/auth/logout', {}),
  saveProfile: (fullName: string) => jsonPost<MeDTO>('/api/me/profile', { fullName }),
};
